import { weeklyUpdates } from '@/mocks/updates';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function UpdateCalendar() {
  return (
    <section id="updates" className="py-16 md:py-24 bg-background-100/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <SectionHeading
          tag="本周更新日历"
          title="这周哪天有新内容，一眼就能看清"
          desc="下面是本周的更新安排，剧集跟随播出节奏同步上新，新片会在片源整理完成后尽快上线。实际时间以站内公告为准。"
        />

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3">
          {weeklyUpdates.map((day) => (
            <div
              key={day.date}
              className={`rounded-xl p-3.5 border ${
                day.highlight
                  ? 'bg-background-50 border-accent-300'
                  : 'bg-background-50/70 border-background-200/70'
              }`}
            >
              <div className="flex items-center justify-between">
                <span className="font-heading text-sm font-bold text-foreground-950">{day.day}</span>
                {day.highlight && (
                  <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
                )}
              </div>
              <div className="text-[11px] text-foreground-500 mt-0.5">{day.date}</div>

              <ul className="mt-3 space-y-2">
                {day.entries.map((entry, idx) => (
                  <li key={`${entry.title}-${idx}`} className="leading-snug">
                    <div className="text-xs font-medium text-foreground-900 truncate">
                      {entry.title}
                    </div>
                    <div className="text-[11px] text-foreground-500 mt-0.5">
                      {entry.type} · {entry.time}
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <p className="flex items-center gap-2 text-xs md:text-sm text-foreground-500 mt-5">
          <i className="ri-information-line"></i>
          高亮日期为更新较为集中的时段，追更时可以参考安排时间。
        </p>
      </div>
    </section>
  );
}